import React, { useEffect, useState } from "react";
import ApiService from "../ApiService";
import MessageTestDetail from "./MessageTestDetail";
import AppointmentRequest from "./AppointmentRequest";
import { Row, Spinner } from "react-bootstrap";
import MessageText from "./MessageText";

const MESSAGE = "MESSAGE";
const DIRECT_MESSAGE = "DIRECT_MESSAGE";
const FREE_PREP_PROGRAM = "FREE_PREP_PROGRAM";

const MessageDetail = props => {
  const [messageUUID] = React.useState(props.messageUUID);
  const [message, setMessage] = useState(null);
  const [component, setComponent] = useState(null);
  const [sentMessage] = useState(props.sentMessage);


  React.useEffect(() => {
    async function getMessage() {
      try {
        const getMessage = await ApiService.getMessage(messageUUID);
        setMessage(getMessage.data);
        getMessage?.data?.latestStatus &&
          props?.setClosingInfo &&
          props.setClosingInfo({
            latestCommentBy: getMessage?.data?.latestCommentBy || "",
            latestComment: getMessage?.data?.latestComment || "",
            latestStatus: getMessage?.data?.latestStatus || ""
          });
      } catch (ex) {
        console.error(ex);
      }
    }
    getMessage();
    return () => {
      props?.setClosingInfo && props.setClosingInfo(null);
    };
  }, []);

  useEffect(() => {
    if (message) {
      if (message.messageType === "TEST_RESULT") {
        setComponent(<MessageTestDetail message={message} messageUUID={messageUUID} sentMessage={sentMessage} />);
      } else if (message.messageType === "APPOINTMENT_REQUEST") {
        setComponent(<AppointmentRequest message={message} messageUUID={messageUUID} sentMessage={sentMessage} />);
      } else if (
        message.messageType === MESSAGE ||
        message.messageType === DIRECT_MESSAGE ||
        message.messageType === FREE_PREP_PROGRAM ||
        message.messageType === "BELUGA"
      ) {
        setComponent(<MessageText message={message} messageUUID={messageUUID} sentMessage={sentMessage} />);
      } else {
        setComponent(<MessageText message={message} messageUUID={messageUUID} sentMessage={sentMessage} />);
      }
    }
  }, [message]);

  if (!component) {
    return (
      <Row>
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </Row>
    );
  } else {
    return <Row>{component}</Row>;
  }
};

export default MessageDetail;
